<template>
  <div class="card-root" @click="$emit('click')" :class="{ mobile: isMobileScan }">
    <div class="scanner-icon-wrapper">
      <template v-if="isMobileScan">
        <img
          class="absolute centered md:w-1/3"
          :src="brandAsset(mobileScan, mobileScanSanne)"
          alt="Mobile Scan"
        />
      </template>
      <!-- Sanne (Figma Select Scanner 5831:11557): two sensor posts, each a
           pale shell with two markers, around the warm-grey figure -->
      <template v-else-if="isSanne && !isFootScanner">
        <div class="sanne-sensor left"><span /><span /></div>
        <div class="sanne-sensor right"><span /><span /></div>
        <img class="absolute centered sanne-body" :src="sanneBody" alt="Human" />
      </template>
      <template v-else>
        <img
          class="absolute top-0 left-0"
          src="../../assets/Discovery/sensor_light.svg"
          alt="Sensor"
        />
        <img
          class="absolute top-0 right-0"
          src="../../assets/Discovery/sensor_light.svg"
          alt="Sensor"
        />
        <img
          class="absolute bottom-0 left-0"
          src="../../assets/Discovery/sensor_light.svg"
          alt="Sensor"
        />
        <img
          class="absolute bottom-0 right-0"
          src="../../assets/Discovery/sensor_light.svg"
          alt="Sensor"
        />
        <img
          v-if="isFootScanner"
          class="absolute centered md:w-1/2"
          src="../../assets/Discovery/foot.svg"
          alt="Human"
        />
        <img
          v-else
          class="absolute centered md:w-1/3"
          src="../../assets/Discovery/human_body.svg"
          alt="Human"
        />
      </template>
    </div>
    <div class="scanner-type">
      {{ scannerTypeText }}
    </div>
    <div class="scanner-name">{{ scanner.name }}</div>
  </div>
</template>

<script>
import brandMode from '@/mixins/brand-mode';
import sanneBody from '@/assets/sanne/discovery/human-body.svg';
import mobileScan from '@/assets/Discovery/mobile-scan.svg';
import mobileScanSanne from '@/assets/sanne/discovery/mobile-scan.svg';

export default {
  name: 'ScannerCard',
  mixins: [brandMode],
  data: () => ({ sanneBody, mobileScan, mobileScanSanne }),
  props: {
    scanner: Object,
  },
  computed: {
    isMobileScan() {
      return this.scanner.type === 'mobile';
    },
    isFootScanner() {
      return this.scanner.type === 'foot';
    },
    scannerTypeText() {
      if (this.isFootScanner) return this.$t('discovery.scanner__foot');

      if (this.isMobileScan) return this.$t('mobileScan.scanner_name');

      return this.$t('discovery.scanner__body');
    },
  },
};
</script>

<style lang="scss" scoped>
.card-root {
  @apply flex flex-col justify-center items-center p-5;
  padding: 10px;
  border-radius: 15px;
  box-shadow: 0 8px 20px 0 rgba(121, 121, 121, 0.25);
  background-color: #fff;
  &.mobile {
    background: rgba(233, 233, 255, 1);
  }
}
.scanner-icon-wrapper {
  @apply relative mx-auto my-3;
  @screen sm {
    @apply mt-auto;
  }
  width: 60%;
  min-width: 140px;
  height: 50%;
}
// Sanne sensor posts: 18 x 180 shell (#EEEBE0), markers 6.75 x 33.75 at the
// shell's upper and lower third, 156 apart (Figma Sensor Left / Right)
.sanne-sensor {
  @apply absolute flex flex-col items-center justify-between;
  top: 50%;
  width: 18px;
  height: 180px;
  padding: 17px 0 18px;
  border-radius: 4px;
  background: #eeebe0;
  transform: translateY(-50%);
  &.left {
    left: calc(50% - 87px);
  }
  &.right {
    left: calc(50% + 69px);
  }
  span {
    width: 6.75px;
    height: 33.75px;
    border-radius: 10px;
    background: #78695f;
  }
}
.sanne-body {
  width: 56px;
  height: 148px;
}
.scanner-type {
  @apply mx-auto text-center text-lg my-5;
  @screen sm {
    @apply text-2xl;
  }
}
.scanner-name {
  @apply text-sm;
  @screen sm {
    @apply mb-auto text-2xl;
  }
  color: #262626;
  opacity: 0.6;
}
.scanner-store-name {
  @apply text-sm;
  @screen sm {
    @apply mb-auto text-2xl;
  }
  color: #262626;
  opacity: 0.6;
}
</style>
